import React, { useEffect, useRef } from "react";
import { CurrencySimple, useResponsiveValue } from "../utils/helper";

const ReceiptAnimation = ({ days, tripFare, totalFare }) => {
    const receiptRef = useRef(null);
    const responsiveFontSize = useResponsiveValue({ xs: 26, sm: 26, lg: 26 });
    useEffect(() => {
        const el = receiptRef.current;
        const timer = setTimeout(() => {
            if (el) el.style.overflow = "visible";
        }, 3600); // match animation duration
        return () => clearTimeout(timer);
    }, []);

    return (
        <div className="receipt-wrapper">
            <div className="roller">
                <div className="roller-slot"></div>
            </div>

            <div ref={receiptRef} className="receipt">
                <h3 className="receipt-title">RECEIPT</h3>
                <div className="divider"></div>

                <div className="receipt-row">
                    <span className="label">Days :</span>
                    <span className="value highlight">{days} Days</span>
                </div>

                <div className="receipt-row">
                    <span className="label">Per Trip Fare:</span>
                    <span className="value highlight">{tripFare.toFixed(2)}</span>
                </div>

                <div className="divider"></div>

                <div className="total-section">
                    <h4>Total Fare</h4>
                    <h2 className="currency">
                        {CurrencySimple(totalFare, "#4ea3a7", responsiveFontSize, "image", null)}
                    </h2>
                </div>
            </div>
        </div>
    );
};

export default ReceiptAnimation;



